import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SmeComponent} from './sme.component';
import {HeaderDetailComponent} from './components/header-detail/header-detail.component';
import {SubDetailComponent} from './components/sub-detail/sub-detail.component';
import {SmeKeysComponent} from './components/sme-keys/sme-keys.component';
import {SmeServicesComponent} from './components/sme-services/sme-services.component';
import {SmeDetailComponent} from './components/sme-detail/sme-detail.component';


@NgModule({
  declarations: [
    SmeComponent,
    HeaderDetailComponent,
    SubDetailComponent,
    SmeKeysComponent,
    SmeServicesComponent,
    SmeDetailComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [SmeComponent]
})
export class SmeModule {
}
